const EyeIconGray = () => (
  <div>
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.08835 6.99849C9.08835 8.15349 8.15502 9.08682 7.00002 9.08682C5.84502 9.08682 4.91168 8.15349 4.91168 6.99849C4.91168 5.84349 5.84502 4.91016 7.00002 4.91016C8.15502 4.91016 9.08835 5.84349 9.08835 6.99849Z"
        stroke="#9E9E9E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 11.826C9.05917 11.826 10.9783 10.6127 12.3142 8.51271C12.8392 7.69021 12.8392 6.30771 12.3142 5.48521C10.9783 3.38521 9.05917 2.17188 7 2.17188C4.94083 2.17188 3.02167 3.38521 1.68583 5.48521C1.16083 6.30771 1.16083 7.69021 1.68583 8.51271C3.02167 10.6127 4.94083 11.826 7 11.826Z"
        stroke="#9E9E9E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);
export default EyeIconGray;
